<app-button
  *ngIf="willShowButton()"
  [text]="privateNoteButtonProperties.text"
  [color]="privateNoteButtonProperties.color"
  [size]="privateNoteButtonProperties.size"
  [Click]="privateNoteButtonProperties.onClick"></app-button>
<div *ngIf="!willShowButton()" [innerHTML]="message"></div>
